import { IPosDevice } from '@/interfaces/IPosDevice';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

export interface ICreatePosDeviceDto {
  name: string;
  branchId: number;
}

export interface IUpdatePosDeviceDto {
  name?: string;
  branchId?: number; // Display only when editing (not sent to backend)
  enabled?: boolean;
}

export class PosDevicesService {
  /**
   * Get all POS devices for a restaurant
   */
  static async getAll(restaurantId: number) {
    const res = await axios.get<IPosDevice[]>(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices`
    );
    return res.data;
  }

  /**
   * Get a single POS device by ID
   */
  static async getOne(restaurantId: number, id: number) {
    const res = await axios.get<IPosDevice>(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices/${id}`
    );
    return res.data;
  }

  /**
   * Create a new POS device
   */
  static async create(restaurantId: number, data: ICreatePosDeviceDto) {
    const res = await axios.post<IPosDevice>(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices`,
      data
    );
    return res.data;
  }

  /**
   * Update an existing POS device
   */
  static async update(
    restaurantId: number,
    id: number,
    data: IUpdatePosDeviceDto
  ) {
    const res = await axios.put<IPosDevice>(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices/${id}`,
      data
    );
    return res.data;
  }

  /**
   * Delete a POS device
   */
  static async delete(restaurantId: number, id: number) {
    const res = await axios.delete(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices/${id}`
    );
    return res.data;
  }

  // NOTE: Admin unlinkDevice has been removed. Unlinking must be done from the POS device itself.

  /**
   * Regenerate token for a POS device.
   * NOTE: Only allowed when device is NOT linked (deviceId === null).
   * If device is linked, unlinking must be done from the POS device first.
   */
  static async regenerateToken(restaurantId: number, id: number) {
    const res = await axios.post<IPosDevice>(
      `${Globals.apiPath}/restaurants/${restaurantId}/pos-devices/${id}/regenerate-token`
    );
    return res.data;
  }
}
